// components/content-management/pages/display/page-display.component.jsx

import PropTypes from 'prop-types';

import {
  PageDisplayContainer,
  PageDisplayRow,
  PageDisplayTitle,
  PageDisplayText,
  PageDisplayOuter
} from './page-display.styles';

const PageDisplay = ({ page }) => {

  return (
    <PageDisplayOuter>
      <PageDisplayContainer>
        <PageDisplayRow>
          <PageDisplayTitle>Title:</PageDisplayTitle>
          <PageDisplayText>{page.title}</PageDisplayText>
        </PageDisplayRow>

        <PageDisplayRow>
          <PageDisplayTitle>Slug:</PageDisplayTitle>
          <PageDisplayText>{page.slug}</PageDisplayText>
        </PageDisplayRow>

        {page.PageType && (
          <PageDisplayRow>
            <PageDisplayTitle>Page Type:</PageDisplayTitle>
            <PageDisplayText>{page.PageType.name}</PageDisplayText>
          </PageDisplayRow>
        )}

        {page.description && (
          <PageDisplayRow>
            <PageDisplayTitle>Description:</PageDisplayTitle>
            <PageDisplayText>{page.description}</PageDisplayText>
          </PageDisplayRow>
        )}

        <PageDisplayRow>
          <PageDisplayTitle>Status:</PageDisplayTitle>
          <PageDisplayText>{page.isActive ? 'Active' : 'Inactive'}</PageDisplayText>
        </PageDisplayRow>

        <PageDisplayRow>
          <PageDisplayTitle>Created By User:</PageDisplayTitle>
          <PageDisplayText>{page.userId ?? '—'}</PageDisplayText>
        </PageDisplayRow>
      </PageDisplayContainer>
    </PageDisplayOuter>
  );
};

export default PageDisplay;